import React from 'react';
import { connect } from 'react-redux';
import './styles.css';

const Blocker = ({ block }) =>
    <div className={`blocker vh-100 vw-100 position-absolute ${block ? 'd-flex' : ' d-none'} align-items-center justify-content-center`}>
        <div className='blocker-bg h-100 w-100 bg-light'></div>
        <div className='blocker-spinner position-absolute'></div>
    </div>;

const mapStateToProps = state => ({ ...state.blocker });

export default connect(mapStateToProps)(Blocker);
